<template>
  <div>
    <div v-if="mode==='view'">
      <div class="input-group">
        <span class="badge badge-warning" v-for="(item,index) in data" :key="index">{{item.title}}</span>
      </div>
    </div>
    <div v-if="mode!=='view'">
      <toggle-button
        class="m-1 toggle-button"
        :value="allValue"
        color="Green"
        :width="65"
        :height="25"
        :sync="true"
        :labels="{unchecked: 'همه', checked: 'همه'}"
        @change="selectAllChanged"
      />
      <toggle-button
        v-if="show"
        class="m-1 toggle-button"
        v-for="(item,index) in options"
        :id="'access'+index"
        :key="index"
        ref="checkbox"
        :value="otherValue[index]"
        color="lightgreen"
        :width="80"
        :height="25"
        :sync="true"
        :labels="{unchecked: item.title, checked: item.title}"
        @change="onValueChanged($event,item)"
      />
    </div>
  </div>
</template>

<script>
import EventBus from "../_framework/bus.js";
import * as $ from "jquery";
import Vue from "vue";
import ToggleButton from "vue-js-toggle-button/src/Button";

export default {
  name: "multi-checkboxes",
  props: {
    data: null,
    header: null,
    headerKey: null,
    mode: null
  },
  data() {
    return {
      show: true,
      model: null,
      allValue: false,
      otherValue: [],
      accesses: [],
      _options: null
    };
  },
  components: {
    ToggleButton
  },
  methods: {
    onValueChanged(e, data) {
      if (e.value) {
        if (
          !this.accesses.find(a => {
            return a.value === data.value;
          })
        ) {
          this.accesses.push(data);
        }
      } else {
        this.accesses = this.accesses.filter(a => {
          return a.value !== data.value;
        });
      }
      this.$emit("dataChanged", this.headerKey, this.accesses);
    },
    selectAllChanged(e) {
      this.show = false;
      for (let index = 0; index < this.options.length; index++) {
        this.otherValue[index] = e.value;
      }
      if (e.value) {
        this.accesses = JSON.parse(JSON.stringify(this.options));
        this.$emit("dataChanged", this.headerKey, this.accesses);
      } else {
        this.accesses = [];
        this.$emit("dataChanged", this.headerKey, []);
      }
      setTimeout(() => {
        this.show = true;
      }, 5);
    }
  },
  beforeMount() {},
  mounted() {
    if (this.mode === "create") {
      this.selectAllChanged({ value: true });
    }
  },
  computed: {
    options: {
      get: function() {
        if (this.mode === "create") {
          this._options = this.data.data;
        }
        return this._options;
      },
      set: function(value) {
        this._options = value;
      }
    }
  },
  watch: {
    mode(val) {
      if (val === "edit") {
        this.show = false;
        this.options = this.header.data;
        this.accesses = this.data;
        this.otherValue = new Array(4);
        this.allValue = false;
        for (let index = 0; index < this.options.length; index++) {
          if (
            this.data.find(d => {
              return d.value === this.options[index].value;
            })
          ) {
            this.otherValue[index] = true;
          } else {
            this.otherValue[index] = false;
          }
        }
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    accesses(val) {
      if (val.length === 4) {
        this.allValue = true;
      } else {
        this.allValue = false;
      }
    }
  }
};
</script>

<style scoped>
.toggle-button {
  font-size: 0.9rem !important;
}
</style>